import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Edit = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M16 10V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H10" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M14.322 3.95887C14.8516 3.4293 15.7102 3.4293 16.2397 3.95886V3.95886C16.7693 4.48843 16.7693 5.34703 16.2397 5.87659L10.8062 11.3102L8.56883 11.6298L8.88845 9.39243L14.322 3.95887Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Edit;